export enum TransferType {
  Deposit = 'deposit',
  Withdraw = 'withdraw',
  TransferAccount = 'transferAccount',
}
